import Seo from 'components/Seo';
import AnimationPage from 'components/AnimationPage';
import CapabilitiesCarrusel from 'components/CapabilitiesCarrusel';
import BrandsCarrusel from 'components/BrandCarrusel';
import OurServicesHero from 'components/ServicesHero';
import "assets/styles/Services.css";

export default function Services() {

  return (
    <AnimationPage>
      <Seo title="Services - Kollectiff" />
      <main>
        <div className="our-services">
            <OurServicesHero />
            
            <CapabilitiesCarrusel />

            <BrandsCarrusel/>
          </div>
         

      </main>
    </AnimationPage>
  );
}
